<!-- @migration-task Error while migrating Svelte code: $$props is used together with named props in a way that cannot be automatically migrated. -->
<script lang="ts">
    import { ConfigurationManager } from "../../ConfigurationManager";
    import type { IGamesController } from "../../controller";
    import { Slot, SLOT_TYPES } from "../../model/Slot";
    import { getAuthInfo, type AuthInfo } from "../../utility/AccountUtility";
    import { getMessagingService, MESSAGE_TYPE, type MessagingService } from "../../utility/ContextHelper.svelte";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    import InputField from "../components/InputField.svelte";
    import PromisedComponentHandler from "../components/PromisedComponentHandler.svelte";
    import ScreenshotGallery from "./ScreenshotGallery.svelte";

    let {
        slot = $bindable(undefined),
        class: Classname = "",
        style = "",
        horizontal = false,
        isSubSlot = false
    }: {
        slot: Slot
        "class"?: string,
        style?: string,
        isSubSlot?: boolean,
        horizontal?: boolean
    } = $props();

    let auth: AuthInfo = getAuthInfo();
    let selectedType: SLOT_TYPES = $state(slot?.type ?? SLOT_TYPES.TEXTURE);

    function resolveOwnerStatus(): Promise<boolean> {
        return Promise.resolve(slot?.game).then((game) => {
            if (game) {
                return game.isOwner(auth);
            }

            return slot.isOwner(auth);
        });
    }


        /**
     * Set to true to display this as a horizontal card
     */

     let msgService: MessagingService = getMessagingService();

     function copyToClipboardCallback() {
        navigator.clipboard.writeText(slot.id);
        msgService.BoradcastMessage("Copied slot id to clipboard", MESSAGE_TYPE.INFO);
     }


     async function updateSlotData(val: string): Promise<boolean> {
        let slotCntrl: IGamesController = ConfigurationManager.getInstance().gamesController;

        try {
            let newSlot: Slot = await slotCntrl.storeSlotData(slot);
        } catch(e) {
            msgService.BroadCastError("Could not update slot name");
            return false;
        }
        msgService.BoradcastMessage("Slot Name updated succesfully", MESSAGE_TYPE.SUCCESS);

        return true;
     }

      function updateSlotType(): void {
          slot = new Slot({
                ...slot,
                type: selectedType,
          });
          if(selectedType == SLOT_TYPES.OBJECT_3D) {
            slot.dimensions = [1,1];
          }
          if(selectedType != SLOT_TYPES.TEXTURE) {
            slot.transparency = false;
          }
      }
      // Slot is a class instance and therefore not deeply reactive, so the slot is reassigned to trigger updates
      function updateTransparency(ev: Event): void {
          slot = new Slot({
                ...slot,
                transparency: (ev.currentTarget as HTMLInputElement).checked,
          });
      }

</script>

{#if slot}
    <div class="{Classname}"  style="{style || ""}">

        <div class="h-100 mb-0 card ">
            <div class="row mx-0 {horizontal ? "card-horizontal w-100" : ""}">

                <div class="{horizontal ? "col-4" : "col-12"} cover-img-wrapper {horizontal ? "card-img-left" : "card-img-top p-0"}">
                    <ScreenshotGallery screenshots={slot.screenshots} class="w-100"></ScreenshotGallery>
                </div>

                <div class="{horizontal ? "col-8" : "col-12"} card-body d-flex flex-column">
                    <h3 class="card-title">
                        <InputField name={"name"} placeholder={"Slot Name"} bind:value={slot.name} ></InputField>
                    </h3>
            
                    <div class="row w-100 mx-0">

                        <h3 class="h6 small text-info text-uppercase mb-3">About</h3>

                        <ul class="list-unstyled mb-7">
                            <li class="py-2">
                                <BootstrapVectorIcon
                                    icon="code-square"
                                    style="height: 1em; width: 1em;"
                                ></BootstrapVectorIcon>
                                
                                <select class="form-select" aria-label="Default select example" bind:value={selectedType} onchange={updateSlotType}>
                                    <option value={SLOT_TYPES.TEXTURE}>{SLOT_TYPES.TEXTURE}</option>
                                    <option value={SLOT_TYPES.OBJECT_3D}>{SLOT_TYPES.OBJECT_3D}</option>
                                    {#if !isSubSlot}
                                        <option value={SLOT_TYPES.COMPLEX}>{SLOT_TYPES.COMPLEX}</option>
                                    {/if}
                                </select>
                                
                            </li>
                            {#if selectedType === SLOT_TYPES.TEXTURE}
                                <li class="py-2 input-group">
                                
                                    <BootstrapVectorIcon
                                        icon="aspect-ratio"
                                        style="height: 1em; width: 1em;"
                                    ></BootstrapVectorIcon>
                                    <InputField name={"dimx"} type={"number"} placeholder={"X"} bind:value={slot.dimensions[0]}></InputField>
                                    <span class="input-group-text">x</span>
                                    <InputField name={"dimy"} type={"number"} placeholder={"Y"} bind:value={slot.dimensions[1]}></InputField>
                                </li>
                                <li class="py-2 d-flex align-items-center">
                                    <BootstrapVectorIcon
                                        icon="circle-half"
                                        style="height: 1em; width: 1em;"
                                        class="me-2 flex-shrink-0"
                                    ></BootstrapVectorIcon>
                                    <label class="form-check form-switch mb-0">
                                        <input class="form-check-input" type="checkbox" name="transparency" checked={slot.transparency} onchange={updateTransparency} />
                                        {slot.transparency ? "Transparent" : "Solid"}
                                    </label>
                                </li>
                            {/if}
                            <li class="py-2">
                                <BootstrapVectorIcon
                                    icon="controller"
                                    style="height: 1em; width: 1em;"
                                ></BootstrapVectorIcon>
                                <a href="#/game/{slot.gameId}">
                                    <PromisedComponentHandler retrievalPromise={slot.game}>
                                        {#snippet children(game)}
                                            {game.name}                                        
                                        {/snippet}
                                    </PromisedComponentHandler>
                                </a>
                            </li>
                            <li class="py-2" style="max-height: 7.2em; overflow-y: auto;">
                                <InputField name={"description"} placeholder={"Description"} type="textarea" bind:value={slot.description}></InputField>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>

    </div>
{/if}

